enum ArtboardError {
    UnableToLoadFile = 'unable_to_load_file',
    UnableToLoadFont = 'unable_to_load_font',
    UnsupportedFile = 'unsupported_file',
}

namespace ArtboardError {
    export function title(error: ArtboardError): string {
        switch (error) {
            case ArtboardError.UnableToLoadFile:
                return 'Unable to load file'
            case ArtboardError.UnableToLoadFont:
                return 'Unable to load font'
            case ArtboardError.UnsupportedFile:
                return 'File type not currently supported'
        }
    }
}

export default ArtboardError
